export const LOAD_BOARD_LABEL = 'Load board';

export const LoadBoardPostingMessages = {
    POSTED: 'Successfully posted to load board'
};
